angular.module('am4').controller('usersCtrl', function($scope, users, $rootScope) {
    var that = this,
        loading,
        searchTerm,
        totalSearchNumber = 0;

    that.showUser = user => that.showInactive || user.enabled;
    that.userPermissions = $rootScope.userPermissions;

    that.users = [];
    that.total = 0;

    initialQuery();

    that.getMore = function() {
        if (loading || that.users.length === that.total) {
            return;
        }

        loading = true;

        that.loaded = false;

        users.query({
            offset: that.users ? that.users.length : 0,
            search: searchTerm
        })
        .then(function(res) {
            that.users = that.users.concat(res.data);
            that.total = res.total_count;
        })
        .finally(function() {
            that.loaded = true;
            loading = false;
        });
    };

    $scope.$watch(function() {
        return that.searchTerm;
    }, function(_searchTerm) {
        that.users = [];
        that.total = 0;

        searchTerm = _searchTerm;
        initialQuery(_searchTerm);
    });

    function initialQuery(searchTerm) {
        loading = true;

        var searchNumber = ++totalSearchNumber;

        that.loaded = false;

        users.query({
            search: searchTerm
        }).then(function(res) {
            // Don't use this ajax request if there is a newer one
            // that has already resolved

            if (totalSearchNumber === searchNumber) {
                that.users = res.data;
                that.total = res.total_count;
            }
        })
        .finally(function() {
            if (totalSearchNumber === searchNumber) {
                that.loaded = true;
                loading = false;
            }
        });
    }
});



// WEBPACK FOOTER //
// ./src/app/controllers/usersCtrl.js